// src/layouts/DashboardLayout.tsx
import { Outlet } from "react-router";
import classes from "./index.module.scss";
import { useDevice } from "../../hooks";
import { TopLoadingBar } from "../../components/TopLoadingBar";
import { useNavigation } from "react-router";
import { DesktopDashboard } from "../../components/Header/DesktopDashboard";
import { Header } from "../../components/Header/"

export const DashboardLayout = () => {
  const navigation = useNavigation();
  const loading = navigation.state !== "idle";
  const { isDesktop } = useDevice();

  return (
    <div className={classes.defaultLayoutContainer}>
      <TopLoadingBar loading={loading} />

      <Header />
      {isDesktop && <DesktopDashboard />}

      <main className={classes.mainContent}>
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
